import type { PaidReport } from './lib/paidReport';

export function ReportPortrait({ report, headingId = 'report-portrait-title' }: { report: PaidReport; headingId?: string }) {
  const positions = [
    { x: 320, y: 68, textX: 320, textY: 24, anchor: 'middle' as const },
    { x: 548, y: 230, textX: 602, textY: 223, anchor: 'end' as const },
    { x: 320, y: 392, textX: 320, textY: 449, anchor: 'middle' as const },
    { x: 92, y: 230, textX: 38, textY: 223, anchor: 'start' as const },
  ];
  const polygon = positions.map(({ x, y }) => `${x},${y}`).join(' ');

  return <section className="mvp-report-portrait" aria-labelledby={headingId}>
    <div className="mvp-portrait-visual">
      <svg viewBox="0 0 640 470" role="img" aria-label={`Personal chart portrait connecting ${report.chartPortrait.nodes.map((node) => node.palace).join(', ')}`}>
        <defs>
          <radialGradient id={`portrait-core-${headingId}`} cx="50%" cy="50%" r="50%"><stop offset="0" stopColor="#bf8c39" stopOpacity=".38" /><stop offset="1" stopColor="#11203a" stopOpacity="0" /></radialGradient>
          <filter id={`portrait-glow-${headingId}`}><feGaussianBlur stdDeviation="4" result="blur" /><feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge></filter>
        </defs>
        <circle className="portrait-halo" cx="320" cy="230" r="178" />
        <circle className="portrait-halo portrait-halo-inner" cx="320" cy="230" r="113" />
        <circle cx="320" cy="230" r="122" fill={`url(#portrait-core-${headingId})`} />
        <polygon className="portrait-constellation" points={polygon} />
        <line className="portrait-axis" x1="320" y1="68" x2="320" y2="392" />
        <line className="portrait-axis" x1="92" y1="230" x2="548" y2="230" />
        <text className="portrait-center-small" x="320" y="217" textAnchor="middle">WHOLE-CHART</text>
        <text className="portrait-center" x="320" y="244" textAnchor="middle">{report.year}</text>
        {report.chartPortrait.nodes.map((node, index) => {
          const pos = positions[index]!;
          return <g key={node.role}>
            <circle className={`portrait-node${node.transformation ? ' has-transform' : ''}`} cx={pos.x} cy={pos.y} r="29" filter={`url(#portrait-glow-${headingId})`} />
            <text className="portrait-node-star" x={pos.x} y={pos.y + 4} textAnchor="middle">{node.stars[0]?.slice(0, 9) || 'WHOLE'}</text>
            <text className="portrait-node-role" x={pos.textX} y={pos.textY} textAnchor={pos.anchor}>{node.role}</text>
          </g>;
        })}
      </svg>
      <div className="mvp-portrait-node-list">{report.chartPortrait.nodes.map((node) => <div key={node.role}><small>{node.role}</small><b>{node.palace}</b><span>{node.stars.join(' · ') || 'Whole-chart context'}{node.transformation ? ` · ${node.transformation}` : ''}</span></div>)}</div>
    </div>
    <div className="mvp-portrait-copy">
      <p className="mvp-kicker">YOUR CHART PORTRAIT · GENERATED FROM FOUR CONNECTED PALACES</p>
      <h3 id={headingId}>{report.chartPortrait.title}</h3>
      <strong>{report.chartPortrait.subtitle}</strong>
      <p>{report.chartPortrait.narrative}</p>
      <dl>{report.chartPortrait.traits.map((trait) => <div key={trait.label}><dt>{trait.label}</dt><dd>{trait.description}</dd></div>)}</dl>
    </div>
  </section>;
}
